export const FAVORITE_WATCHLIST_KIND: {
  SEARCH: 'search';
  TICKET: 'ticket';
} = {
  SEARCH: 'search',
  TICKET: 'ticket',
};
